import * as S from "src/styles/styledcomponent/views/Rop02/ToastPopup"

interface toastProps {
  isShow: boolean
}

export const ToastPopup: React.FC<toastProps> = ({ isShow }) => {
  return (
    <S.ToastWrap isShow={isShow}>
      <S.ToastText>휴대폰 인증을 진행하세요.</S.ToastText>
    </S.ToastWrap>
  )
}
